import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { hideErrorModal } from '../../actions';

class ApiErrorModal extends Component{
    render() {
        const {show, hideErrorModal, errorMsg} = this.props;

        return (
            <Modal show={show} onHide={hideErrorModal}>
                <Modal.Header closeButton>
                    <Modal.Title> <a href='https://youtu.be/siwpn14IE7E'> Danger! </a> </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    We are terribly sorry, but the DAM has sprung a leak!
                    <br/>
                    <br/>
                    Please reload the page. Some recent work may be lost.
                    <br/>
                    <br/>
                    Alternatively, please reach out to one of the DAM developers, and keep this window open. There is data embedded in the page that may be useful in diagnosing the problem.
                    <hr/>
                    Technical Details: 
                    <br/>
                    <code> {errorMsg} </code>
                </Modal.Body>
            </Modal>
        );
    }
}

const mapDispatchToProps = {
    hideErrorModal
};

const mapStateToProps = state => ({
    show:     state.ui.error.show,
    errorMsg: state.ui.error.text
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ApiErrorModal);

ApiErrorModal.propTypes = {
    show:           PropTypes.bool.isRequired,
    hideErrorModal: PropTypes.func.isRequired,
    errorMsg:       PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/components/apiErrorModal/ApiErrorModal.js